import { render, staticRenderFns } from "./game-flg.vue?vue&type=template&id=01501642"
import script from "./game-flg.vue?vue&type=script&lang=js"
export * from "./game-flg.vue?vue&type=script&lang=js"
import style0 from "./game-flg.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-flg.vue
// module id = fyiL
// module chunks = 0